import { searchWktByCoords } from 'components/MapComponent/constants';
import { transform } from 'ol/proj';
import React, { useContext, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { LanguageService } from 'services/languageService';
import {
  resetAteListAction,
  resetFoundLayerAction,
  setCurrentAteAction,
  setFoundLayerAction,
  setNeedUpdateInfoAction,
} from 'store/actions/layers';
import { toggleOpenLayerModalAction } from 'store/actions/mainPage';
import MapContext from 'components/MapComponent/MapContext';
import 'components/MapComponent/styles.css';
import Overlay from 'ol/Overlay';
import { Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const LayerInfoModal: React.FC = () => {
  const {
    currentLayerParent,
    currentLayerTitle,
    foundInfo,

    foundInfoCoords,
    searchByClickZlevel,
    currentLayerId,
    needUpdateFoundInfo,
    layer_scale_1_50_vector,
  } = useAppSelector((state) => state.layers);
  const { isLogged, lang } = useAppSelector((state) => state.mainPage);
  const { map } = useContext(MapContext);
  const popupContainerRef = useRef<HTMLDivElement | null>(null);

  const dispatch = useAppDispatch();
  const title = `${currentLayerParent}, ${currentLayerTitle}`;

  const handleCloseInfo = () => {
    dispatch(toggleOpenLayerModalAction());
    dispatch(resetFoundLayerAction());
  };

  useEffect(() => {
    if (!map || !foundInfo || !currentLayerId) return;

    const popupOverlay = new Overlay({
      element: popupContainerRef.current!,
      position: foundInfoCoords,
      autoPan: {
        animation: {
          duration: 250,
        },
      },
    });

    map.addOverlay(popupOverlay);

    return () => {
      map.removeOverlay(popupOverlay);
    };
  }, [map, foundInfo, currentLayerId]);

  useEffect(() => {
    // disable searching if exist layer_scale_1_50_vector
    if (needUpdateFoundInfo && foundInfo && !layer_scale_1_50_vector) {
      const [lon, lat] = transform(foundInfoCoords, 'EPSG:3857', 'EPSG:4326');
      const coords = [lon.toFixed(6), lat.toFixed(6)];

      searchWktByCoords(
        String(currentLayerId),
        coords,
        String(searchByClickZlevel),
        lang,
        isLogged
      )
        .then((res) => {
          const wkt = res.wkt;
          if (!wkt) return;

          dispatch(
            setFoundLayerAction(
              wkt,
              res.value,
              foundInfoCoords,
              res.soato,
              +searchByClickZlevel
            )
          );
        })
        .catch((e) => {
          dispatch(resetFoundLayerAction());
        })
        .finally(() => {
          dispatch(setNeedUpdateInfoAction(false));
        });
    }
  }, [needUpdateFoundInfo]);

  return (
    <Box
      sx={{
        display: foundInfo ? 'flex' : 'none',
        flexDirection: 'column',
        backgroundColor: 'white',
        p: 1,
        pt: 0,
        maxWidth: 450,
        minWidth: 400,
        bottom: '20px',
        left: '-46px',
        position: 'absolute',
        borderRadius: '8px',
      }}
      className="ol-popup-info"
      ref={popupContainerRef}
    >
      {foundInfo ? (
        <>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'start',
            }}
          >
            <Typography fontSize={'1rem'} fontWeight={700}>
              {title}
            </Typography>

            <IconButton onClick={handleCloseInfo}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ mb: 1 }}>
            <Typography dangerouslySetInnerHTML={{ __html: foundInfo }} />
          </Box>
        </>
      ) : (
        <></>
      )}
    </Box>
  );
};
